import { type DeliveryTypeType } from '~/constants/deliveryType';

import { type DeliveryNote, type TradeAddress } from '~/types/deliveryNote';

import { type FormDeliveryNoteFormFields } from '~/modules/ai-parser-review/components/FormDeliveryNote';

export const updateDeliveryData = (
  draft: DeliveryNote,
  formData: FormDeliveryNoteFormFields,
) => {
  draft.transaction.delivery.shipFrom.consignment.movement.means =
    formData.transaction.delivery.shipFrom.consignment.movement.means!;
  draft.transaction.delivery.shipFrom.tradeAddress = formData.transaction
    .delivery.shipFrom.tradeAddress as TradeAddress;

  draft.transaction.delivery.shipTo.tradeAddress = formData.transaction.delivery
    .shipTo.tradeAddress as TradeAddress;

  draft.transaction.agreement.deliveryTerms.code = formData.transaction
    .agreement.deliveryTerms.code as DeliveryTypeType;
};
